/**
 * Redux Store Configuration
 * Using Redux Toolkit for simpler state management
 */

import { configureStore } from '@reduxjs/toolkit';
import assetReducer from './slices/assetSlice';
import projectReducer from './slices/projectSlice';
import customerReducer from './slices/customerSlice';
import authReducer from './slices/authSlice';
import mapReducer from './slices/mapSlice';
import uiReducer from './slices/uiSlice';
import searchReducer from './slices/searchSlice';
import reportReducer from './slices/reportSlice';
import countReducer from './slices/countSlice';
import scopeReducer from './slices/scopeSlice';

export const store = configureStore({
  reducer: {
    asset: assetReducer,
    project: projectReducer,
    customer: customerReducer,
    auth: authReducer,
    map: mapReducer,
    ui: uiReducer,
    search: searchReducer,
    report: reportReducer,
    count: countReducer,
    scope: scopeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore non-serializable values in specific paths
        ignoredPaths: ['map.viewport'],
        ignoredActions: ['map/setViewport', 'map/updateViewport'],
      },
    }),
  devTools: import.meta.env.DEV,
});

export default store;
